import React, { useState } from "react";
import { Modal, Image } from "semantic-ui-react";
import { NewAssistance } from "../../components/NewAssistance/NewAssistance";
//import {NewAssistance3d} from "../../components/NewAssistence3d/NewAssistance3d";
import { useAuth } from "../../hooks";
import { image } from "../../assets";
import "./Chatbot.scss";

/**
 * Chatbot:
 * - Muestra un botón flotante en la esquina inferior derecha.
 * - Al pulsarlo, abre un popup/modal con tu componente de chat.
 */
export function Chatbot() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  // Función para alternar apertura/cierre del modal
  const handleOpenClose = () => setOpen((prev) => !prev);

  // Determinar el assistantId según el rol
  let assistantId = "";
  let avatar = "";
  switch (user?.user?.role) {
  
    case "partner":
      assistantId = "679b706c4a60050b051babba"; // tu ID concreto
      avatar = image.teacherAvatar;
      break;
    case "teacher":
      assistantId = "679ba7104a60050b051dbfd2";
      avatar = image.teacherAvatar;
      break;
    case "student":
      assistantId = "679b706c4a60050b051babba";
      avatar = image.teacherAvatar;
      break;
    case "institution":
      assistantId = "679ba08d4a60050b051d9aa3";
      avatar = image.teacherAvatar;
      break;
    default:
      assistantId = "679ba7104a60050b051dbfd2"; // Por si no coincide ningún rol
      avatar = image.teacherAvatar;
      break;
  }

  return (
    <> 
      {/* Botón flotante */}
      <div className="chatbot-button" onClick={handleOpenClose}>
        <Image src={avatar} alt="Chatbot" className="chatbot-avatar" />
      </div>

      {/* Modal con el chat */}
      <Modal
        open={open}
        onClose={handleOpenClose}
        closeIcon
        size="small"
        className="chatbot-modal" // IMPORTANTE
      >
        <Modal.Content scrolling>
          <div className="institution-publi">
            <NewAssistance assistantId={assistantId} avatarImg={avatar}/>
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
}
